/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Confirm_New_PasswordInputs */

const en_auth__confirm_new_password = /** @type {(inputs: Auth__Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm new password`)
};

/**
* | output |
* | --- |
* | "Confirm new password" |
*
* @param {Auth__Confirm_New_PasswordInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__confirm_new_password = /** @type {((inputs?: Auth__Confirm_New_PasswordInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Confirm_New_PasswordInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__confirm_new_password(inputs)
});